<template>
  <th v-if="isHeader">
    {{ title }}
  </th>
  <span v-else-if="rowData">
    {{ getDay(rowData.request) }}
  </span>
</template>

<script>
import VuetableFieldMixin from 'vuetable-2/src/components/VuetableFieldMixin'

export default {
  mixins: [VuetableFieldMixin],
  props: {
    rowData: {
      type: Object,
      default: () => {
        return {request: {pickup: {day: '-'}}}
      },
    },
  },
  methods: {
    getDay: request => {
      return request && request.pickup ? request.pickup.day : ''
    },
  },
  name: 'Day',
}
</script>
<style src="@/styles/styled_cell.less" lang="less" scoped="true"></style>
